import { Pagination, Sorting } from '../../../types';

export const DEFAULT_SORTING: Sorting = {
  column: 'createdAt',
  direction: 'desc',
};

export const DEFAULT_PAGINATION: Pagination = { page: 1, perPage: 15 };
